<template>
    <div v-if="isMounted" style="height: 450px">
        <div class="left card">
            <div class="card-body">
                <div>
                    <el-form label-width="140px"
                             :disabled="!$parentInfo.studentCart.dialog_DiscountType.canUseDiscounts">
                        <el-form-item label="优惠类型">
                            <el-select v-model="$parentInfo.studentCart.dialog_DiscountType.discounts" placeholder="请选择"
                                       multiple @change="chooseDiscount()"
                                       :loading="$parentInfo.studentCart.select_loading">
                                <el-option-group
                                        v-for="item in orderDiscountTypes"
                                        :key="item.id">
                                    <el-option
                                            v-for="item1 in item.discountType_details"
                                            :key="item1.id"
                                            :label="item.name"
                                            :value="item1.id"
                                            :disabled="item1.status">
                                        <span style="float: left">{{ item.name }} {{item1.remark}}</span>
                                        <span style="margin-left: 20px; color: #8492a6; ">{{ item1.balance }}</span>
                                    </el-option>
                                </el-option-group>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="个人折扣优惠">
                            <el-select v-model="$parentInfo.studentCart.dialog_DiscountType.selfDiscounts_id"
                                       placeholder="请选择" multiple @change="chooseDiscount()">
                                <el-option-group
                                        v-for="(group,key) in $parentInfo.studentCart.dialog_DiscountType.selfDiscounts"
                                        :key="key"
                                        :label="key">
                                    <el-option
                                            v-for="item in group"
                                            :key="item.id"
                                            :label="item.discount_name"
                                            :value="item.id">
                                        <span style="float: left">{{ item.discount_name }}</span>
                                        <span style="float: right; color: #8492a6; font-size: 13px">{{ item.discount }}</span>
                                    </el-option>
                                </el-option-group>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="个人线下现金优惠">
                            <div>{{$parentInfo.studentCart.dialog_DiscountType.selfOfflineCashDiscounts}}</div>
                        </el-form-item>
                        <el-form-item label="个人线下现金优惠">
                            <el-input-number v-model="$parentInfo.studentCart.dialog_DiscountType.selfOfflineCashDiscount"
                                             :max="$parentInfo.studentCart.dialog_DiscountType.selfOfflineCashDiscounts"
                                             :min="0" label="个人现金优惠"></el-input-number>
                        </el-form-item>
                        <el-form-item label="个人线上现金优惠">
                            <div>{{$parentInfo.studentCart.dialog_DiscountType.selfOnlineCashDiscounts}}</div>
                        </el-form-item>
                        <el-form-item label="个人线上现金优惠">
                            <el-input-number v-model="$parentInfo.studentCart.dialog_DiscountType.selfOnlineCashDiscount"
                                             :max="$parentInfo.studentCart.dialog_DiscountType.selfOnlineCashDiscounts"
                                             :min="0" label="个人现金优惠"></el-input-number>
                        </el-form-item>
                        <el-form-item label="总优惠">
                            <el-input v-model="allDiscount" size="small" disabled type="number"
                                      style="width: 100px"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <!--                <div class="text-right">-->
                <!--                    <el-button type="primary" size="small" @click="handleStoreCartDiscount()"-->
                <!--                               :loading="$parentInfo.studentCart.dialog_DiscountType.button_loading">确 定-->
                <!--                    </el-button>-->
                <!--                </div>-->
            </div>
        </div>
        <div class="right card">
            <div class="card-body">
                <div style="float: right;width:10%"  v-if="$parentInfo.powers.includes(185)">
                    <div v-if="$parentInfo.studentCart.dialog_SettleAccounts.payUrl">
                        <el-popover
                                placement="right"
                                trigger="click">
                            <img :src="$parentInfo.studentCart.dialog_SettleAccounts.payUrl" style="width: 500px;height: 500px">
                            <div slot="reference" @click="" style="width: 50px;height: 50px">
                                <img :src="$parentInfo.studentCart.dialog_SettleAccounts.payUrl" alt=""
                                     style="width: 80px;height: 80px">
                            </div>
                        </el-popover>
                    </div>
                    <div v-else>
                        无
                    </div>
                </div>
                <div style="clear: both"></div>
                <el-form size="mini">
                    <el-form-item label="订单总价">
                        {{$parentInfo.studentCart.sumPay|currency('￥',2)}}
                    </el-form-item>
                    <el-form-item label="家长">
                        <el-select v-model="$parentInfo.studentCart.invoiceForm.parent_id"
                                   placeholder="请选择家长">
                            <el-option
                                    v-for="item in $parentInfo.student.parents"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                <span style="float: left">{{ item.name }}</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">{{item.parent_identity }}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-row :gutter="20" v-for="(payment,index) in $parentInfo.studentCart.dialog_SettleAccounts.payments" :key="index">
                        <el-col :span="1">
                            <div style="height:30px;width:30px;display: flex; justify-content:center;align-items: center;">
                                <div class="circle" :style="{'background':payment.status=='finished'?'green':'red'}" @click="handRefreshCartPayment(payment)"></div>
                            </div>
                        </el-col>
                        <el-col :span="9">
                            <el-form-item label="支付方式" >
                                    <el-select v-model="payment.paymentType_id"
                                               placeholder="请选择支付方式"
                                               :disabled="!payment.canDel"
                                               style="width:200px"
                                               @change="handRefreshCartPayment(payment)">
                                        <el-option
                                                v-for="item in $parentInfo.studentCart.invoiceForm.payment_types"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-input :disabled="payment.paymentType_id===5" v-model="payment.balance" v-if="payment.paymentType_id!=16" @change="handRefreshCartPayment(payment)"></el-input>
                            <el-select v-model="payment.other_id"
                                       placeholder="请选择押金"
                                       :disabled="!payment.canDel"
                                       @change="handRefreshCartPayment(payment)"
                                       v-else>
                                <el-option
                                        v-for="item in $parentInfo.studentCart.dialog_SettleAccounts.studentDeposits"
                                        :key="item.id"
                                        :label="item.has_rent"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="3">
                            <div>
                                <el-popover
                                        placement="right"
                                        title=""
                                        width="270"
                                        trigger="click">
                                    <div class="qrcode_box">
                                        <canvas id="msg" class="qrcode"></canvas>
                                        <div style="text-align: center">
                                            <el-upload
                                                    class="upload-demo"
                                                    :action="action"
                                                    :on-preview="handlePreview"
                                                    :on-remove="handleRemove"
                                                    :file-list="fileList"
                                                    :limit="1"
                                                    list-type="picture">
                                                <el-button size="small" type="primary">本地上传</el-button>
                                            </el-upload>
                                        </div>
                                    </div>
                                    <el-button slot="reference" @click="getQRCodeMsg(payment)">点击上传</el-button>
                                </el-popover>
                            </div>

                        </el-col>
                        <el-col :span="2">
                            <el-button type="primary" @click="handleDelPayment(payment)"  :disabled="!payment.canDel">删除</el-button>
                        </el-col>
                        <el-col :span="4">
                            <div style="height:30px;width:30px;display: flex; justify-content:center;align-items: center;">
                                <div v-if="payment.bill_url">
                                    <el-popover
                                            placement="right"
                                            trigger="click">
                                        <img :src="payment.bill_url" style="width: 500px;height: 500px">
                                        <div slot="reference" @click="" style="width: 50px;height: 50px">
                                            <img :src="payment.bill_url" alt=""
                                                 style="width: 50px;height: 50px">
                                        </div>
                                    </el-popover>
                                </div>
                                <div v-else>
                                    无
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                    <div style="text-align: right">
                        <el-button type="primary" @click="handleAddPayment()">新增支付方式</el-button>
                    </div>
                    <el-form-item label="结算差价">
                        {{remainPay|currency('￥',2)}}
                    </el-form-item>
                </el-form>
                <div style="text-align: right">
                    <el-button type="primary" @click="handleChangeSettlementInvoice()"
                               :loading="$parentInfo.studentCart.button_loading">转为待结算
                    </el-button>
                    <el-button type="primary" @click="handleCheckOut()"
                               :loading="$parentInfo.studentCart.button_loading">确 认 支 付
                    </el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import QRCode from 'qrcode'
    export default {
        name: "Dialog_SettleAccounts",
        data() {
            return {
                isMounted: false,
                personalCashDiscount: 0,
                selfDiscounts_id: '',
                show:false,
                QRCodeMsg:'234',
                choosePayment_id:'',
                fileList: [],
            };
        },
        destroyed(){
            this.$parentInfo.studentCart.invoiceForm.parent_id='';
        },
        computed: {
            action(){
                return "https://server.modijiaoyu.com/api/cart/paymentBill?payment_id="+this.choosePayment_id
            },
            orderDiscountTypes: function () {
                return this._.orderBy(this.$parentInfo.studentCart.dialog_DiscountType.discountTypes, 'status', 'asc');
            },

            allDiscount: function () {
                let sumDiscount = 0;
                for (let i in this.$parentInfo.studentCart.dialog_DiscountType.discounts) {
                    if (this.$parentInfo.studentCart.dialog_DiscountType.discountType_details[this.$parentInfo.studentCart.dialog_DiscountType.discounts[i]].type === 'balance') {
                        sumDiscount += parseFloat(this.$parentInfo.studentCart.dialog_DiscountType.discountType_details[this.$parentInfo.studentCart.dialog_DiscountType.discounts[i]].balance)
                    }
                }
                sumDiscount += parseFloat(this.$parentInfo.studentCart.dialog_DiscountType.selfOfflineCashDiscount+this.$parentInfo.studentCart.dialog_DiscountType.selfOnlineCashDiscount);
                for (const key in this.$parentInfo.studentCart.dialog_SettleAccounts.payments) {
                    if (this.$parentInfo.studentCart.dialog_SettleAccounts.payments[key].paymentType_id==5) {
                        this.$parentInfo.studentCart.dialog_SettleAccounts.payments[key].balance= sumDiscount;
                        break;
                    }
                }
                //this.$parentInfo.studentCart.invoiceForm.payment_types[5].balance = sumDiscount;
                return sumDiscount
            },
            remainPay: function () {
                let sum = 0;
                for (const key in this.$parentInfo.studentCart.dialog_SettleAccounts.payments) {
                    if (this.$parentInfo.studentCart.dialog_SettleAccounts.payments[key].balance) {
                        sum += parseFloat(this.$parentInfo.studentCart.dialog_SettleAccounts.payments[key].balance);
                    }
                }
                // sum +=this.$parentInfo.studentCart.dialog_DiscountType.selfCashDiscount
                return this.$parentInfo.studentCart.sumPay - sum ;
            },
        },
        mounted() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleDiscountType();
            this.isMounted = true;
        },
        methods: {
            handleDiscountType() {
                this.$wApi.send(this.$parentInfo.path, 'get_discountTypes', {
                    'selections': this.$store.state.modal.data.selections,
                    'student_id': this.$parentInfo.student_id,
                    'choose_cart_classHour_ids': this.$store.state.modal.data.choose_cart_classHour_ids,
                    'choose_cart_shop_ids': this.$store.state.modal.data.choose_cart_shop_ids,
                });
            },
            handleStoreCartDiscount() {
                this.$wApi.send(this.$parentInfo.path, 'store_cart_discount', {
                    'discounts': this.$parentInfo.studentCart.dialog_DiscountType.discounts,
                    'selfDiscounts_id': this.$parentInfo.studentCart.dialog_DiscountType.selfDiscounts_id,
                    'selfCashDiscount':this.$parentInfo.studentCart.dialog_DiscountType.selfOfflineCashDiscount+this.$parentInfo.studentCart.dialog_DiscountType.selfOnlineCashDiscount,
                    // 'otherDiscount': this.otherDiscount,
                    'student_id': this.$parentInfo.student_id,
                    'selections': this.$store.state.modal.data.selections,
                });
            },
            chooseDiscount() {
                this.$parentInfo.studentCart.dialog_DiscountType.discountTypes = JSON.parse(JSON.stringify(this.$parentInfo.studentCart.dialog_DiscountType.standbyDiscountTypes));
                if (this.$parentInfo.studentCart.dialog_DiscountType.discounts.length > 0) {
                    for (let i in this.$parentInfo.studentCart.dialog_DiscountType.discounts) {
                        if (this.$parentInfo.studentCart.dialog_DiscountType.discountType_details[this.$parentInfo.studentCart.dialog_DiscountType.discounts[i]].overlay === 1) {
                            let vm = this;
                            this.$parentInfo.studentCart.dialog_DiscountType.discountTypes[this.$parentInfo.studentCart.dialog_DiscountType.discountType_details[this.$parentInfo.studentCart.dialog_DiscountType.discounts[i]].discountType_id].discountType_details.forEach((item, index) => {
                                if (item.id !== vm.$parentInfo.studentCart.dialog_DiscountType.discounts[i]) {
                                    item.status = true;
                                }
                            });
                        }
                        if (this.$parentInfo.studentCart.dialog_DiscountType.discountTypes[this.$parentInfo.studentCart.dialog_DiscountType.discountType_details[this.$parentInfo.studentCart.dialog_DiscountType.discounts[i]].discountType_id].overlay === 1) {
                            let vm = this;
                            for (let j in this.$parentInfo.studentCart.dialog_DiscountType.discountTypes) {
                                if (this.$parentInfo.studentCart.dialog_DiscountType.discountTypes[j].id !== this.$parentInfo.studentCart.dialog_DiscountType.discountTypes[vm.$parentInfo.studentCart.dialog_DiscountType.discountType_details[vm.$parentInfo.studentCart.dialog_DiscountType.discounts[i]].discountType_id].id) {
                                    this.$parentInfo.studentCart.dialog_DiscountType.discountTypes[j].discountType_details.forEach((item) => {
                                        item.status = true;
                                    });
                                }
                            }
                        } else {
                            let vm = this;
                            for (let j in this.$parentInfo.studentCart.dialog_DiscountType.discountTypes) {
                                if (this.$parentInfo.studentCart.dialog_DiscountType.discountTypes[j].id !== this.$parentInfo.studentCart.dialog_DiscountType.discountTypes[vm.$parentInfo.studentCart.dialog_DiscountType.discountType_details[vm.$parentInfo.studentCart.dialog_DiscountType.discounts[i]].discountType_id].id) {
                                    if (this.$parentInfo.studentCart.dialog_DiscountType.discountTypes[j].overlay === 1) {
                                        this.$parentInfo.studentCart.dialog_DiscountType.discountTypes[j].discountType_details.forEach((item) => {
                                            item.status = true;
                                        });
                                    }
                                }
                            }
                        }
                    }
                }

                for (const key in this.$parentInfo.studentCart.dialog_SettleAccounts.payments) {
                    if (this.$parentInfo.studentCart.dialog_SettleAccounts.payments[key].paymentType_id==5) {
                        this.$parentInfo.studentCart.dialog_SettleAccounts.payments[key].balance=this.allDiscount;
                        break;
                    }
                }
                this.$wApi.send(this.$parentInfo.path, 'store_cart_discount', {
                    'discounts': this.$parentInfo.studentCart.dialog_DiscountType.discounts,
                    'selfDiscounts_id': this.$parentInfo.studentCart.dialog_DiscountType.selfDiscounts_id,
                    'selfCashDiscount': this.$parentInfo.studentCart.dialog_DiscountType.selfOfflineCashDiscount+this.$parentInfo.studentCart.dialog_DiscountType.selfOnlineCashDiscount,
                    // 'otherDiscount': this.otherDiscount,
                    'student_id': this.$parentInfo.student_id,
                    'selections': this.$store.state.modal.data.selections,
                });
            },
            handleInstallment() {
                // if (this.$parentInfo.studentCart.dialog_DiscountType.discounts.length != 0) {
                //     this.$message.error('使用优惠券后不能分期');
                // }else{
                this.$parentInfo.studentCart.innerVisible = true;
                // }
                // this.$Win.openModal('Dialog_Installment', 341, 200, '分期比例', {
                //     'student_id': this.$parentInfo.student_id,
                //     'selections': this.$parentInfo.studentCart.chosenCart,
                //     'sumPay': this.$parentInfo.studentCart.sumPay,
                // });
            },
            //分期付款
            handleChangeInstallment() {
                this.$parentInfo.studentCart.dialog_Installment.button_loading = true;
                this.$wApi.send(this.$parentInfo.path, 'changeInstallment', {
                    'proportion': this.$parentInfo.studentCart.dialog_Installment.proportion,
                    'selfCashDiscounts': this.$parentInfo.studentCart.dialog_DiscountType.selfOfflineCashDiscount+this.$parentInfo.studentCart.dialog_DiscountType.selfOnlineCashDiscount,
                    'selections': this.$store.state.modal.data.selections,
                    'sumPay': this.remainPay,
                    'student_id': this.$parentInfo.student_id,
                    'choose_cart_classHour_ids': this.$store.state.modal.data.choose_cart_classHour_ids,
                    'choose_cart_shop_ids': this.$store.state.modal.data.choose_cart_shop_ids,
                });
            },
            handleCheckOut() {
                for (const key in this.$parentInfo.studentCart.dialog_SettleAccounts.payments) {
                    if (this.$parentInfo.studentCart.dialog_SettleAccounts.payments[key].status!='finished') {
                        this.$message({
                            message: '有支付方式未完成验证',
                            type: 'warning'
                        });
                        return 0;
                    }
                }
                this.$confirm('确认结算?', '提示', {
                    StartReturn: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$parentInfo.studentCart.button_loading = true;
                    this.$wApi.send(this.$parentInfo.path, 'checkOutCart', {
                        'change_class_id': this.$parentInfo.studentCart.change_class_id,
                        'payments': this.$parentInfo.studentCart.dialog_SettleAccounts.payments,
                        'selections': this.$store.state.modal.data.selections,
                        'choose_cart_classHour_ids': this.$store.state.modal.data.choose_cart_classHour_ids,
                        'choose_cart_shop_ids': this.$store.state.modal.data.choose_cart_shop_ids,
                        'student_id': this.$parentInfo.student_id,
                        'parent_id': this.$parentInfo.studentCart.invoiceForm.parent_id,
                        'cart_use_lessons': this.$parentInfo.studentCart.cart_use_lessons,
                        'selfCashDiscount': this.$parentInfo.studentCart.dialog_DiscountType.selfOfflineCashDiscount+this.$parentInfo.studentCart.dialog_DiscountType.selfOnlineCashDiscount-this.$parentInfo.studentCart.dialog_DiscountType.installmentSelfCashDiscounts,
                        'installmentSelfCashDiscounts':  this.$parentInfo.studentCart.dialog_DiscountType.installmentSelfCashDiscounts,
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            handleChangeSettlementInvoice(){
                for (const key in this.$parentInfo.studentCart.dialog_SettleAccounts.payments) {
                    if (this.$parentInfo.studentCart.dialog_SettleAccounts.payments[key].status!='finished') {
                        this.$message({
                            message: '有支付方式未完成验证',
                            type: 'warning'
                        });
                        return 0;
                    }
                }
                this.$confirm('确认转换为待结算合同?', '提示', {
                    StartReturn: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$parentInfo.studentCart.button_loading = true;
                    this.$wApi.send(this.$parentInfo.path, 'give_carts_to_settlementInvoice', {
                        'change_class_id': this.$parentInfo.studentCart.change_class_id,
                        'payments': this.$parentInfo.studentCart.dialog_SettleAccounts.payments,
                        'selections': this.$store.state.modal.data.selections,
                        'choose_cart_classHour_ids': this.$store.state.modal.data.choose_cart_classHour_ids,
                        'choose_cart_shop_ids': this.$store.state.modal.data.choose_cart_shop_ids,
                        'student_id': this.$parentInfo.student_id,
                        'parent_id': this.$parentInfo.studentCart.invoiceForm.parent_id,
                        'cart_use_lessons': this.$parentInfo.studentCart.cart_use_lessons,
                        'selfCashDiscount': this.$parentInfo.studentCart.dialog_DiscountType.selfOfflineCashDiscount+this.$parentInfo.studentCart.dialog_DiscountType.selfOnlineCashDiscount-this.$parentInfo.studentCart.dialog_DiscountType.installmentSelfCashDiscounts,
                        'installmentSelfCashDiscounts':  this.$parentInfo.studentCart.dialog_DiscountType.installmentSelfCashDiscounts,
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            handleAddPayment(){
                this.$wApi.send(this.$parentInfo.path, 'add_cart_payment', {
                    'student_id': this.$parentInfo.student_id,
                });
            },
            handleDelPayment(item){
                this.$wApi.send(this.$parentInfo.path, 'del_cart_payment', {
                    'cart_payment_id': item.id,
                });
            },
            handRefreshCartPayment(item){
                this.$wApi.send(this.$parentInfo.path, 'refresh_cart_payment', {
                    'cart_payment_id': item.id,
                    'paymentType_id':item.paymentType_id,
                    'balance':item.balance,
                    'other_id':item.other_id
                });
            },
            getQRCodeMsg(payment){
                this.QRCodeMsg='http://server.modijiaoyu.com/api/cart/storePaymentBill?cart_payment_id='+payment.id
                this.choosePayment_id=payment.id
                var msg= document.getElementById('msg')
                // 将获取到的数据（val）画到msg（canvas）上
                QRCode.toCanvas(msg, this.QRCodeMsg, function (error) {})
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log(file);
            }
        }
    }
</script>

<style scoped lang="scss">
    .left {
        float: left;
        width: 300px;
    }

    .right {
        margin-left: 310px;
    }

    .circle {
        border-radius: 50%;
        width: 20px;
        height:  20px;
        line-height: 20px;
    }

    .qrcode_box{
        width: 250px!important;
        height:  400px!important;
        .qrcode{
            width: 250px!important;
            height: 250px!important;
        }
    }

    #msg{
        width:250px !important;
        height:250px !important;
    }
</style>
